import React, { useState, useEffect } from 'react';
import '../SmcLife/IndexLife.css';
import loader from './Images/SmcLoader.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";
import ShareQuotations from './ShareQuotations/ShareQuotations';


const LifeQuoteEnquiry = (props) => {
    const [isLoader, setLoader] = useState(true);
    const [copyText, setCopyText] = useState(false);
    const [IsAscendingOrder, setAscendingOrder] = useState(true); // State to track sort order
    const [btnGst, setBtnGst] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'IND'
    });

    const handleCopy = () => {
        setCopyText(true);
        setTimeout(() => setCopyText(false), 2000);
    };
    const handleGst = (e) => {
        setBtnGst(e.target.checked);
        props.setGst(e.target.checked);
        
    }
 
    useEffect(() => {
        setLoader(props.Data.length > 0 ? false : true);
    }, [props.Data]);

    const handleSort = () => {
        props.setAscendingOrder(props.IsAscendingOrder ? false : true); // Toggle sorting order
    };
/*
    const sortedData = props.Data.slice().sort((a, b) => {
        if (sortOrder === 'asc') {
            return a.premium - b.premium;
        } else {
            return b.premium - a.premium;
        }
    });*/
   // console.log("prop",props)
    
    return (
        <section className="ExclusiveGSTPlan mt-3">
            <div className="ExclusiveMiddle">
                <div className="Plan_found_box">
                    <h3 className="QuoteHead">{props.Data.length > 0 ? props.Data.length : (props.isLoading && props.Data.length===0) ? <img className="load" src={loader} /> :""} {props.Data.length === 1 ? "Plan" : props.Data.length === 0 ? "No Plan" : "Plans"} Found <i onClick={() => setShowModal(true)} className="fa fa-share-alt"></i></h3>
                    <div className="ENQ_box">
                        <CopyToClipboard text={props.enq} onCopy={handleCopy}>
                            <p className="LeadID" >Lead ID:<span id="textCopeid" >{props.enq} &nbsp;<i className="far fa-copy"></i></span></p>
                        </CopyToClipboard>
                        {copyText && <div className="Enq_popup">Copied!</div>}
                    </div>
                    {showModal && (<ShareQuotations showModal={showModal} EnquiryNo={props.enq} LotNo={props.QuoteRequest.LotNo} MobileNo={props.QuoteRequest.MobileNo} hiddenQuotes={props.hiddenQuotes} closeModal={() => setShowModal(false)} />)}
                </div>

                { props.Data.length >0 && < div className="share_Quotes">
                    <span className="SarQoute_Size2" onClick={handleSort}>
                        Sort by Premium {props.IsAscendingOrder ? <FaSortAmountDown className="React-Sort-Icon" style={{ color: '#30b524' }} /> : <FaSortAmountUp className="React-Sort-Icon" style={{ color: '#30b524' }} />}
                    </span>
                    <div className="form-check form-switch gst_switch ENQ_box">
                        <label className="gst-toggle-label">
                            <input className="form-check-input check_gst" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={btnGst} onChange={(e) => handleGst(e)} />
                            <span className="text_gst  LeadID">Premium with GST</span>
                        </label>
                    </div>
                    
                </div>}
                
            </div>
        </section>
    );
};

export default LifeQuoteEnquiry;
